import SchedulingEvent from './SchedulingEvent';

export default SchedulingEvent;